<template>
  <div v-if="letters.length > 0">
    <div class="card invoice-header-card mb-3">
      <div class="card-body invoice-header-content py-2">
        <div class="form-row align-items-end">
          <div class="form-group col-12 col-md-4 mb-2">
            <label class="control-label mb-1"><b>Seleccionar cliente</b></label>
            <div class="client-field">
              <div class="client-field__typeahead">
                <typeahead :name="'client'" :placeh="'Ingrese cliente'" :clean-on="false" v-on:choosed="clientChoosed" :default="config.defaultClient" :externalsrc="srcClients" limit-chars="4"/>
              </div>
              <button type="button" class="btn btn-success client-field__add" title="Nuevo cliente" @click="newClient">
                <i class="bi bi-person-plus"></i>
              </button>
            </div>
          </div>

          <div class="form-group col-12 col-md-3 mb-2">
            <label class="control-label mb-1"><b>Comprobante</b></label>
            <div class="comprobante-pill">
              <div v-if="letters[0].letter!='P'" class="comprobante-pill__segment comprobante-pill__segment--letter">
                <select v-if="letters.length > 1" v-model="header.letter" class="comprobante-pill__control select-iva">
                  <option v-for="letter in letters" :key="letter.letter">{{letter.letter}}</option>
                </select>
                <input v-else v-model="header.letter" type="text" class="comprobante-pill__control" disabled>
              </div>

              <div class="comprobante-pill__segment comprobante-pill__segment--pos">
                <select v-if="posnumbers.length > 1" v-model="header.pos" class="comprobante-pill__control">
                  <option v-for="pos in posnumbers" :key="pos.pos" :value="pos.pos">{{pos.pos}}</option>
                </select>
                <input v-else v-model="header.pos" type="text" class="comprobante-pill__control" disabled>
              </div>

              <div class="comprobante-pill__segment comprobante-pill__segment--number">
                <input v-model="header.number" id="number" type="text" class="comprobante-pill__control">
              </div>
            </div>
          </div>

          <div v-if="showPricelist" class="form-group col-12 col-md-3 mb-2">
            <label class="control-label mb-1"><b>Lista de precios</b></label>
            <select v-model="header.pricelist_id" class="form-control">
              <option v-for="(priceslist,index) in priceslists" :key='index' :value="priceslist.id">{{priceslist.name}}</option>
            </select>
          </div>

          <div v-if="showChoosedate" class="form-group col-12 col-md-2 mb-2">
            <label class="control-label mb-1"><b>Fecha FC</b></label>
            <datepicker-component v-on:datechoosed="dateUpdated"/>
          </div>
        </div>

        <div v-if="showservicedate" class="service-period-row">
          <span class="service-period-row__badge badge badge-pill badge-success">Servicio</span>
          <span class="service-period-row__label">Desde</span>
          <datepicker-component v-on:datechoosed="fromdateUpdated" required/>
          <span class="service-period-row__sep"><i class="bi bi-arrow-right"></i></span>
          <span class="service-period-row__label">Hasta</span>
          <datepicker-component v-on:datechoosed="todateUpdated" required/>
          <span class="service-period-row__sep">&middot;</span>
          <span class="service-period-row__label">Vence FC</span>
          <datepicker-component v-on:datechoosed="expdateUpdate" required/>
        </div>
      </div>
    </div>

    <ModalNuevoCliente
      :clientId="clientIdParent"
      v-if="showModal"
      @edit="changeClientId"
      @close="showModal=false"
    />

  </div>
</template>

<script>
import typeahead from '../global/Typeahead.vue';
import datepickerComponent from '../global/Datepicker-component.vue';
import ModalNuevoCliente from "../../clientes/Nuevo-cliente.vue";
//import shortkey from 'vue-shortkey';

export default {
  props: ['config', 'showPricelist', 'showChoosedate', 'posnumbers', 'showservicedate', 'storageKey'],
  data: function() {
    return {
      header:JSON.parse(localStorage.getItem('header:' + (this.storageKey || 'pos'))) || {
        client_id: null,
        cc_only: null,
        pricelist_id: null,
        number: null,
        letter: null,
        receipt_date: null,
        receipt_servicefromdate: null,
        receipt_servicetodate: null,
        receipt_serviceexpdate: null,
        pos: null
      },
      letters: [],
      showModal: false,
      clientIdParent: null,
      priceslists : [],
      srcClients: '/api/clients/getClients',
      clientIva: ''
    }
  },
  mounted: function () {
    var vm = this;
    vm.header.pos = this.config.pos_default;
    vm.letters = vm.posnumbers.filter(e => e.pos === vm.header.pos).shift().numbers;
    vm.header.letter = vm.letters[0].letter;

    vm.numberUpdated();
    vm.$emit('headerchanged', this.header);
  },
  watch: {
    'header.pos': { // Esto envia los datos de header cada vez que cambian al receipt donde seran adjuntados al payload
      handler: function () {
        var vm = this;
        vm.letters = vm.posnumbers.filter(e => e.pos === vm.header.pos).shift().numbers;
        vm.header.letter = vm.letters[0].letter;

        this.clientIvaType(this.header.client_id);
        this.numberUpdated();
        this.$emit('headerchanged', this.header);
      }
    },
    'header.pricelist_id': { // Esto envia los datos de header cada vez que cambian al receipt donde seran adjuntados al payload
      handler: function () {
        this.$emit('headerchanged', this.header);
      }
    },
    'header.letter': { // Esto envia los datos de header cada vez que cambian al receipt donde seran adjuntados al payload
      handler: function () {
        this.numberUpdated();
        this.$emit('headerchanged', this.header);
      }
    },
    'header.client_id': { // Esto envia los datos de header cada vez que cambian al receipt donde seran adjuntados al payload
      handler: function (a) {
        this.clientIvaType(a);
        this.clientCC(a);
        this.$emit('headerchanged', this.header);
        this.$emit('clientchanged', this.header.client_id, this.header.cc_only);
      }
    },
    priceslists: function (newpriceslists) { //Cuando se cargen las listas de precios actualiza el select con la configurada como default si existe, sino la primera de la lista
      if (newpriceslists.length) {
        this.header.pricelist_id = (this.pricelist_exist(this.config.pricelist_default) ? this.config.pricelist_default : this.priceslists[0].id );
      } else {
        this.header.pricelist_id = this.config.pricelist_default;
      }
    }
  },
  methods: {
    fromdateUpdated: function (date) {
      this.header.service_fromdate = date;
    },
    todateUpdated: function (date) {
      this.header.service_todate = date;
    },
    expdateUpdate: function (date) {
      this.header.service_expdate = date;
    },
    dateUpdated: function (date) {
      this.header.date = date;
    },
    numberUpdated: function () {
      this.header.number=this.letters.filter(e => e.letter === this.header.letter).shift().number;
    },
    clientIvaType: function($id) {
      var app = this;
      if ( ($id!=null) && ($id>0) && (this.letters.length > 1) ) {
        window.axios.get('/api/clients/getClient/'+$id)
        .then(function (response) {
          var client = response.data.data;
          if (client.iva_type=="Responsable Inscripto") {
            app.header.letter = app.letters.filter(e => e.letter !== 'B').shift().letter;
          } else {
            app.header.letter = "B";
          }
        })
        .catch(function (error) {
          alert(error.message);
        });
      }
    },
    clientCC: function($id) {
      var app = this;
      window.axios.get('/api/clients/getClient/'+$id)
      .then(function (response) {
        var cc_only = response.data.data.cc_only;
        app.header.cc_only = cc_only;
      })
      .catch(function (error) {
        alert(error.message);
      });
    },
    getPricelist: function () {
      var app = this;
      window.axios.get('/api/priceslist/getPriceList')
      .then(function (response) {
        app.priceslists = response.data.data;
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    clientChoosed(data) {
      this.header.client_id=data.id;
      this.clientIva = data.iva;
    },
    pricelist_exist(pricelist_id) {
      const filteredList = this.priceslists.filter(e => e.id === pricelist_id);
      return !!filteredList.length;
    },
    changeClientId() {
      this.clientIdParent = this.header.client_id;
      this.showModal= true;
    },
    newClient(){
      if (this.header.client_id === 1 || this.header.client_id === null) {
        this.clientIdParent=null;
        this.showModal = true;
      }else {
        this.changeClientId();
      }
    },
   },
   created () {
    var vm = this;
    vm.getPricelist();
   },
   components:{
    typeahead,
    datepickerComponent,
    ModalNuevoCliente
  }
}
</script>
